export default __webpack_public_path__ + "static/media/add-button.d59439ce.svg";